export default __webpack_public_path__ + "static/media/doc-spanish.b7cae736.pdf";